export default {
  appAlert: {
    actionButtonFn: null,
    actionButtonText: 'Accept',
    color: null,
    dismissibleTimeOut: 8000,
    type: 'info', // success, info, warning, and error.
    text: null,
    visible: false
  },
  appDialog: {
    acceptButtonFn: null,
    cancelButtonFn: null,
    contentText: null,
    contentComponent: null,
    contentComponentProps: null,
    hideActionButtons: false,
    hideTitle: false,
    optionsActionsButtons: {
      alignButtons: 'right', // left, center, right
      acceptButtonText: 'Aceptar',
      acceptButtonType: 'submit',
      acceptButtonClass: '',
      acceptButtonHide: false,
      acceptButtonLoading: false,
      acceptButtonDisabled: false,
      cancelButtonText: 'Cancelar',
      cancelButtonType: 'button',
      cancelButtonClass: '',
      cancelButtonHide: false,
      cancelButtonDisabled: false,
      defaultBehaviourButtons: true
    },
    title: 'Titulo dialog',
    visible: false
  },
  appLoadingLayer: {
    text: null,
    translucid: false,
    visible: false
  },
  appNotifications: {
    items: []
  },
  extraSmallDevice: false,
  smallDevice: false,
  mediumDevice: false,
  largeDevice: false,
  referred: null,
  selectedPlace: null,
  showQrAlert: false,
  urlRedirect: null,
  userActivity: null
}
